module.exports = __webpack_public_path__ + "img/sdg13.a02659a1.svg";